module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "fade-transition ng-scope",
    attrs: {
      "ng-view": ""
    }
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Detalhamento da Aprovação de Entidade")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": _vm.breadcrumb
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [(_vm.detalhe.entityApprovalType) ? _c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-caret-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), (_vm.detalhe.entityApprovalType === 'FIRST_APPROVAL' && _vm.detalhe.eventStatus !== 'DONE') ? _c('span', [_vm._v("Primeira Aprovação")]) : _vm._e(), _vm._v(" "), (_vm.detalhe.entityApprovalType === 'SECOND_APPROVAL' && _vm.detalhe.eventStatus !== 'DONE') ? _c('span', [_vm._v("Segunda Aprovação")]) : _vm._e(), _vm._v(" "), (_vm.detalhe.eventStatus === 'DONE') ? _c('span', [_vm._v("Aprovação Finalizada")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding",
    attrs: {
      "ssm-lte-loading": "loading-info"
    }
  }, [(!_vm.analise.approvalResult) ? _c('div', {
    staticClass: "mailbox-controls with-border text-center"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mailbox-read-info"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('span', {
    staticClass: "col-md-2 control-label link-muted"
  }, [_vm._v("Status:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.detalhe.eventStatus === 'DONE') ? _c('p', {
    staticClass: "form-control-static text-success"
  }, [_vm._v("APROVADO")]) : _vm._e(), _vm._v(" "), (_vm.analise.approvalResult === 'REJECTED') ? _c('p', {
    staticClass: "form-control-static text-danger"
  }, [_vm._v("REJEITADO")]) : _vm._e(), _vm._v(" "), (_vm.analise.approvalResult === '' && _vm.detalhe.eventStatus !== 'DONE') ? _c('p', {
    staticClass: "form-control-static text-primary"
  }, [_vm._v("AGUARDANDO VALIDAÇÃO")]) : _vm._e()]), _vm._v(" "), (_vm.detalhe.updatedAt) ? _c('div', [_c('span', {
    staticClass: "col-md-2 control-label link-muted"
  }, [_vm._v("Data da operação:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('label', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.dataAtualizacao))])])]) : _vm._e(), _vm._v(" "), (_vm.analise.justify) ? _c('div', [_c('span', {
    staticClass: "col-md-2 control-label link-muted"
  }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('label', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.analise.justify))])])]) : _vm._e(), _vm._v(" "), (_vm.detalhe.proposalRelease) ? _c('div', [_c('span', {
    staticClass: "col-md-2 control-label link-muted"
  }, [_vm._v("Liberado para proposta:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.detalhe.proposalRelease === 'true') ? _c('label', {
    staticClass: "form-control-static text-success"
  }, [_vm._v("SIM")]) : _vm._e(), _vm._v(" "), (_vm.detalhe.proposalRelease === 'false') ? _c('label', {
    staticClass: "form-control-static text-danger"
  }, [_vm._v("NÃO")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.detalhe.user) ? _c('div', [_c('span', {
    staticClass: "col-md-2 control-label link-muted"
  }, [_vm._v("Atendido por:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('label', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.detalhe.user.userName))])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "col-md-2 control-label link-muted"
  }, [_vm._v("Entidade:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('label', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.detalhe.entity.businessName))])])]), _vm._v(" "), _c('div', {
    attrs: {
      "ng-if": "mainEntDetAppCtrl.approval.entity.codForERp != null"
    }
  }, [_c('span', {
    staticClass: "col-md-2 control-label link-muted"
  }, [_vm._v("Código no Sapiens:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('label', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.detalhe.entity.codForERp))])])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "col-md-2 control-label link-muted"
  }, [_vm._v("Criado em:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('label', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.dataCriacao))])])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "col-md-2 control-label link-muted"
  }, [_vm._v("Atualizado em:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('label', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.dataAtualizacao))])])])])])]), _vm._v(" "), (_vm.detalhe.entityApprovalType) ? _c('div', [_c('a', {
    staticClass: "btn btn-default btn-sm",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar à tela anterior\n            ")])]) : _vm._e()])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f96e17ce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/validação/entidades/DetalheValidaEntidade.vue
// module id = 2107
// module chunks = 1